"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllowMaxAge = exports.getAllowMethodsHeader = exports.getAllowHeadersHeader = exports.getAllowCredentialsHeader = exports.getAllowOriginHeader = void 0;
function accessControl(name) {
    return `access-control-${name}`;
}
function getAllowOriginHeader() {
    return accessControl(`allow-origin`);
}
exports.getAllowOriginHeader = getAllowOriginHeader;
function getAllowCredentialsHeader() {
    return accessControl(`allow-credentials`);
}
exports.getAllowCredentialsHeader = getAllowCredentialsHeader;
function getAllowHeadersHeader() {
    return accessControl(`allow-headers`);
}
exports.getAllowHeadersHeader = getAllowHeadersHeader;
function getAllowMethodsHeader() {
    return accessControl(`allow-methods`);
}
exports.getAllowMethodsHeader = getAllowMethodsHeader;
function getAllowMaxAge() {
    return accessControl(`max-age`);
}
exports.getAllowMaxAge = getAllowMaxAge;
